import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=72daca89&"
import script from "./Popups.vue?vue&type=script&lang=js&"
export * from "./Popups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72daca89')) {
      api.createRecord('72daca89', component.options)
    } else {
      api.reload('72daca89', component.options)
    }
    module.hot.accept("./Popups.vue?vue&type=template&id=72daca89&", function () {
      api.rerender('72daca89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/services/Popups.vue"
export default component.exports